import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import GUIset_TextArea from "./gui/GUIset_TextArea";
import Template from "./TheTemplate";

const CommonElement = () => {
	useEffect(() => {
		document.title = "Common Element: find common elements in arrays";
	}, []);

	const [guiTxtArea, guiTxtAreaChange] = useState(
		"1,2,4,5,5,5\n2,3,4,5,5,10\n1,2,5,5,10,20"
	);
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxtArea != "") {
			arrs = T.str_toListArray_noEmpty(guiTxtArea,",");
			Timer.start();
			process();
			txt_time = Timer.stop_print();
			BuildResult();
			//clear ------------
			arrs = null;
		}
	};

	var arrs;
	var txt_result = "";
	var txt_time = "";

	function process() {
		if(arrs.length == 0){ txt_result = "{}";}
		else { 			
			var list_final = arrs[0].sort();
			for(var i = 1; i < arrs.length; i++){
				var list2 = arrs[i].sort();
				list_final = T.arrs_getCommon(list_final, list2);
			}		
		}
		txt_result = list_final.toString();;
	}

	function BuildResult() {
		partResultChange(Template.simple3size("key1","Result", txt_time, txt_result, 22, 20, 22) );
	}

	return (
		<GUIset_TextArea
		title = "Common Elements"
		desc = "Find common elements in arrays."
		label1 = "Arrays"
		guiTxtArea = {guiTxtArea}
		guiTxtAreaChange={guiTxtAreaChange}
		buttonClick={buttonClick1}
		partResult={partResult}
	/>
	);
};

export default CommonElement;
